// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"112":"book","328":"admin","535":"login","685":"register"}[chunkId] + "." + {"112":"6afbccaa","328":"e6526423","535":"46091093","685":"aa8a5d76"}[chunkId] + ".css";
};